export default __webpack_public_path__ + "static/media/Pokeball.c12e1adc.png";